import { createTheme, ThemeOptions } from '@mui/material';
import { svSE } from '@mui/material/locale';

const themeOptions: ThemeOptions = {
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
  palette: {
    background: {
      default: '#f4f4f4',
      paper: '#ffffff',
    },

    error: {
      main: '#C1666B',
      dark: '#a34d51',
      light: '#d08589',
      contrastText: '#fff',
    },

    customColors: {
      richBlack: '#090909', //Black ish
      cultured: '#F5F5F5', //White ish
      emerald: '#0E8E70', //Turquoise ish
      emeraldHover: '#1fb794',
      bdazzledBlue: '#345995', //Blue ish
      bdazzledBlueHover: '#347195', //Blue ish hover
      lightBdazzledBlue: '#5b83c0', //Lighter Blue
      fuzzyWuzzy: '#C1666B', //Light Red ish
      grannySmith: '#ACEB98', //Light Green ish
      grannySmithHover: '#A4D88C',
      canary: '#FFF689', //Yellow ish
      color3: '#F7FAFD', //To be replaced, the BrandColors doesn't have anything equal to this.
      softerGreen: '#e4eed4', //Softer green for backgrounds
      inputBackground: '#FFFCFC', //Input background color
      gray: '#666', //Gray ish
    },
    status: {
      neutral: '#345995',
      approved: '#0E8E70',
      rejected: '#C1666B',
      pending: 'orange',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          boxShadow: 'none',

          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          backgroundColor: '#548A73',
          color: 'F5F5F5',
          fontWeight: 'bold',
          padding: '10px 15px 10px 15px',
          margin: '5px',
        },
      },
    },
  },
};

// svSE gives MUI's own texts, such as the Autocomplete's "No options" and "Loading…", in Swedish.
export const theme = createTheme(themeOptions, svSE);
